import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, Inject, OnDestroy, NgZone } from '@angular/core';
import { AuthenticationService } from '../../../../../services/security';
import { LoginUserRequestModel } from "../../../../../shared/LoginUserRequestModel";
import { Router, ActivatedRoute } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppConsts } from "../../../../../shared/app-consts";
import { ViewEncapsulation } from '@angular/core';
import { LocalUserDataModel } from '../../../../../shared/models/localUserData.model';
import { RecaptchaService } from '../../../../../services/security/recaptcha-service';
import { LoaderService } from '../../../../loader';
import { DOCUMENT } from '@angular/common';
import { EnumAuthenticateState } from '@shared/security/enum-auth-state';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isLoading: boolean = false;
  returnUrl: string;
  loginForm: FormGroup;
  loginError: any = false;
  emailPattern: string = AppConsts.EMAIL_PATTERN;
  submitted: boolean = false;
  rememberMe: any = false;
  web_Url: string = AppConsts.API_URL;
  public storeUser: LoginUserRequestModel = new LoginUserRequestModel("", "", false);
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  _isCheckedRecaptcha: boolean = false;
  set isCheckedRecaptcha(value: boolean) {
    this._isCheckedRecaptcha = value;
  }
  get isCheckedRecaptcha(): boolean { return this._isCheckedRecaptcha; }

  constructor(private route: ActivatedRoute, private service: AuthenticationService,
    private router: Router,
    public formBuilder: FormBuilder,
    private recaptchaService: RecaptchaService,
    private loaderService: LoaderService, private renderer: Renderer2,
    @Inject(DOCUMENT) private _document, private zone: NgZone) {
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.loaderService.hideLoader();
    this.addRecaptchaScript();
    let email = "";
    const rememberMe = localStorage.getItem(AppConsts.REMEMBER_ME);
    if (rememberMe && rememberMe != null && rememberMe != "")
      this.rememberMe = JSON.parse(rememberMe);

    if (this.rememberMe) {
      email = localStorage.getItem(AppConsts.USER_MAIL);
    }
    this.storeUser = new LoginUserRequestModel(email, "", this.rememberMe);
    this.buildLoginForm();
  }

  get f() { return this.loginForm.controls; }

  ngAfterViewInit() {
  }

  buildLoginForm() {
    this.loginForm = this.formBuilder.group({
      Email: [
        "",
        Validators.compose([
          Validators.maxLength(100),
          Validators.pattern(this.emailPattern),
          Validators.required
        ])
      ],
      Password: [
        "",
        Validators.compose([
          Validators.minLength(8),
          Validators.required 
        ])
      ],
      RememberMe: [""]
    });

    this.loginForm.controls['Email'].valueChanges.subscribe(value => {
      this.storeUser.Email = value;
    });

    this.loginForm.controls['Password'].valueChanges.subscribe(value => {
      this.storeUser.Password = value;
    });

    this.loginForm.controls['RememberMe'].valueChanges.subscribe(value => {
      this.rememberMe = value;
    });
    this.loginForm.controls['Email'].setValue(this.storeUser.Email);
    this.loginForm.controls['RememberMe'].setValue(this.storeUser.RememberMe);
  }

  login() {
    this.submitted = true;
    this.loginError = false;

    if (AppConsts.IS_ENV_PRODUCTION && !this.isCheckedRecaptcha || this.loginForm.invalid) {
      return;
    }
    this.isLoading = true;
    let user = new LoginUserRequestModel(this.storeUser.Email, btoa(this.storeUser.Password), this.storeUser.RememberMe);
    user.RecaptchaToken = AppConsts.IS_ENV_PRODUCTION ? this.storeUser.RecaptchaToken : "DEV";
    user.IsTwoFactorRememberClient = true;
    this.service.login(user).subscribe((response: any) => {
      if (response && response != null && !response.IsError) {
        if (response.CnxEtatCompte == EnumAuthenticateState.ChgMDP) {
          const link = response.LinkResetPassword;
          this.zone.runOutsideAngular(() => {
            window.location.href = link;
          });
        }
        if (response.IsTwoFactorRequired) {
          sessionStorage.setItem(AppConsts.REMEMBER_ME, this.rememberMe);
          sessionStorage.setItem(AppConsts.DecisielCurrentEmail, this.storeUser.Email);
          this.router.navigate(['login/send-code']);
        }
        else
          this.signIn(response);
      }
      else {
        this.loginError = true;
      }
      this.isLoading = false;
    }, error => {
      this.loginError = true;
      this.isLoading = false;
    });
    return false;
  }

  signIn(response: any) {
    this.service.signIn(response, this.storeUser.Email, this.rememberMe);
    this.router.navigate(['']);
    if (this.returnUrl != 'undefined' && this.returnUrl != null && this.returnUrl.length > 0 && this.returnUrl != '/') {
      this.zone.runOutsideAngular(() => {
        window.location.href = this.returnUrl;
      });
    }
  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptcha(); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  showResponse(response) {
    //call to a backend to verify against recaptcha with private key
  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': AppConsts.RECAPTCHA_SITE_KEY,
      'callback': (response) => {
        this.isCheckedRecaptcha = true;
        this.storeUser.RecaptchaToken = response;
      }
    });
  }

  redirectToLostPassword() {
    this.router.navigate['/lostpassword'];
  }
}
